import { useState, useEffect } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useClient = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    firstname: "",
    lastname: "",
    personal: "",
    email: "",
    mobile: ""
  });

  useUpdateEffect(() => {
    if (defaultPageSize > 0) {
      fetchList();
    }
   }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/client/list", filter)
      setItems(response.data.clients);
      setTotal(response.data.total);
      return response.data.clients
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/client/all", requestData)
      setItems(response.data.clients);
      setTotal(response.data.total);
      return response.data.clients
    } catch (error) {

      console.error("error:" + error);
    }
  }

  const add = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/client/create`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const search = async (client, count) => {
    try {
      const requestData = {
        client: client,
        count: count,
      };

      const response = await automobyApi.post("/client/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/client/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          client_id: id
        };
        const response = await automobyApi.post(`/client/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (client) => {
    setItems(items.map(item =>
      item.id === client.id ? client : item
    ));
  }
 

  const clientService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { clientService };
}